/**
 * Modern navigation component for dashboard views
 * Positioned at bottom with clean, integrated design
 */

import React from 'react';
import { DashboardViewMode, DashboardView } from '../../types/Star';

interface DashboardNavigationProps {
  currentView: DashboardViewMode;
  onViewChange: (view: DashboardViewMode) => void;
  counts?: {
    all: number;
    starred: number;
    member: number;
    generate?: number;
    findcompanies?: number;
  };
}

export const DashboardNavigation: React.FC<DashboardNavigationProps> = ({
  currentView,
  onViewChange,
  counts
}) => {
  const views: Omit<DashboardView, 'icon' | 'description'>[] = [
    {
      id: 'all',
      label: 'All Leads'
    },
    {
      id: 'starred',
      label: 'Starred'
    },
    {
      id: 'member',
      label: 'My Leads'
    },
    {
      id: 'generate',
      label: 'Generate Lead'
    },
    {
      id: 'findcompanies',
      label: 'Find Companies'
    }
  ];

  return (
    <div style={{
      padding: '14px 0 4px 0'
    }}>
      <div className="container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0'
      }}>
        {views.map((view, index) => {
          const isActive = currentView === view.id;
          const count = counts ? counts[view.id] : 0;

          return (
            <button
              key={view.id}
              onClick={() => onViewChange(view.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 24px',
                border: 'none',
                backgroundColor: 'transparent',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                minWidth: '120px',
                justifyContent: 'center',
                opacity: isActive ? 1 : 0.7,
                transform: isActive ? 'translateY(-1px)' : 'translateY(0)'
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.opacity = '0.9';
                  e.currentTarget.style.transform = 'translateY(-0.5px)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.opacity = '0.7';
                  e.currentTarget.style.transform = 'translateY(0)';
                }
              }}
            >
              {/* Active indicator */}
              {isActive && (
                <div style={{
                  position: 'absolute',
                  top: '-1px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '32px',
                  height: '2px',
                  backgroundColor: 'white',
                  borderRadius: '1px',
                  boxShadow: '0 1px 3px rgba(255, 255, 255, 0.3)'
                }} />
              )}

              <span style={{
                fontSize: '15px',
                fontWeight: isActive ? '600' : '500',
                letterSpacing: '0.3px'
              }}>
                {view.label}
              </span>

              <span style={{
                fontSize: '12px',
                fontWeight: '500',
                opacity: 0.9,
                background: isActive
                  ? 'rgba(255, 255, 255, 0.25)'
                  : 'rgba(255, 255, 255, 0.2)',
                padding: '2px 6px',
                borderRadius: '10px',
                minWidth: '20px',
                textAlign: 'center',
                backdropFilter: 'blur(8px)',
                lineHeight: '1.2'
              }}>
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};